import type { AppointmentManageTargetDto } from '@shared/core/bookings'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { BookingsService } from 'src/services/bookings.service'

// Cache key
export const GET_APPOINTMENT_MANAGE_TARGET_CACHE_KEY = 'get-appointment-manage-target'

// Resolve where a booking-keyed "Manage your appointment" link should land
export function useAppointmentManageTarget(bookingId: string, options?: UseQueryOptions<AppointmentManageTargetDto>) {
  const handleRetry = useHandleRetry()
  const cacheKey = [GET_APPOINTMENT_MANAGE_TARGET_CACHE_KEY, bookingId]
  return useQuery(cacheKey, () => BookingsService.getManageTarget(bookingId), {
    enabled: !!bookingId,
    staleTime: ms('5 minutes'),
    retry: handleRetry,
    ...options,
  })
}
